import BaseRPCHandler from "./BaseRPCHandler";

export default class EthGetEncryptionPublicKeyHandler extends BaseRPCHandler {
    constructor() {
        super('eth_getEncryptionPublicKey');
    }
    
    async handle(provider, request) {

    }
    
}